export class ChatFeatures {
  public webSearchEnabled: boolean;
  public lastRetrieved: Date;

  constructor(data: any) {
    this.webSearchEnabled = data.webSearchEnabled as boolean;
    this.lastRetrieved = data.lastRetrieved
      ? new Date(data.lastRetrieved)
      : new Date();
  }
}
